import { render, staticRenderFns } from "./SubportionReview.vue?vue&type=template&id=426ba44f&scoped=true&"
import script from "./SubportionReview.vue?vue&type=script&lang=js&"
export * from "./SubportionReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426ba44f",
  null
  
)

export default component.exports